import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

import { MenuItem, CrossPlatformNavigationButton, SidebarWrapper } from './css';
import EN from '../../EN.json';
import FR from '../../FR.json';
import request, { sof1ApiHost, sof2ApiHost } from '../utils/request';
import { sof1HomeUrl, sof2HomeUrl } from '../utils/constant';

const locale = localStorage.getItem('locale');
const translations = locale === 'FR' ? FR : EN;

const crossPlatformRedirect = platform => {
  if (platform === 'sof1')
    window.location.replace(
      request.getSSOLoginState()
        ? `${sof1ApiHost}/users/sso-login`
        : sof1HomeUrl
    );

  if (platform === 'sof2')
    window.location.replace(
      request.getSSOLoginState()
        ? `${sof2ApiHost}/users/sso-login`
        : sof2HomeUrl
    );
};

const isMenuSelected = menu => useLocation().pathname === menu;

const Menu = ({ userRights }) => (
  <SidebarWrapper>
    <ul>
      <MenuItem>
        <CrossPlatformNavigationButton
          onClick={() => crossPlatformRedirect('sof2')}
        >
          {translations.menu.sof2}
        </CrossPlatformNavigationButton>
      </MenuItem>
      <MenuItem isSelected={isMenuSelected('/orders')}>
        <Link to="/orders">{translations.menu.orders}</Link>
      </MenuItem>
      {userRights.isUserPageVisible && (
        <MenuItem isSelected={isMenuSelected('/users')}>
          <Link to="/users">{translations.menu.users}</Link>
        </MenuItem>
      )}
      {userRights.isBulkUploadVisible && (
        <MenuItem isSelected={isMenuSelected('/bulk-upload')}>
          <Link to="/bulk-upload">{translations.menu.bulkUploadUsers}</Link>
        </MenuItem>
      )}
    </ul>
  </SidebarWrapper>
);

Menu.propTypes = {
  userRights: PropTypes.shape({
    isUserPageVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool
  }).isRequired
};

export default Menu;
